import React, {useRef, useEffect, useState} from "react";
import useInView from "./utils/useInView";
import {useGetVideos, useVideos} from "./stores/otherStore";

const VideoReviews = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;
    const videoRefs = useRef([]);
    const [playingIndex, setPlayingIndex] = useState(null);
    const [ref, inView] = useInView();

    const videos = useVideos();
    const getVideos = useGetVideos();

    useEffect(() => {
        void getVideos();
    }, [getVideos]);

    // сброс при смене страницы
    useEffect(() => {
        setPlayingIndex(null);
    }, [currentPage]);

    const handlePlayPause = async (globalIndex) => {
        const video = videoRefs.current[globalIndex];
        if (!video) return;

        try {
            if (video.paused) {
                // стопим все остальные
                videoRefs.current.forEach((v, i) => {
                    if (i !== globalIndex && v && !v.paused) v.pause();
                });

                await video.play();
                setPlayingIndex(globalIndex);
            } else {
                video.pause();
                setPlayingIndex(null);
            }
        } catch (err) {
            console.warn("Play interrupted:", err);
        }
    };

    const totalPages = Math.ceil(videos.length / itemsPerPage);
    const currentVideos = videos.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    return (
        <div
            ref={ref}
            className={`opacity-0 scale-90 transition-all duration-500 
        ${inView ? "animate-fadeIn" : ""}`}
        >
            <div className="bg-[#FAFDFE] mt-10">
                <div className="col-span-3 flex justify-center">
                    <div className="text-center md:text-left">
                        <h3 className="md:text-4xl text-xl font-bold mb-4 break-words">
                            Отзывы наших клиентов
                        </h3>
                    </div>
                </div>
                <div className="mx-auto md:px-5 w-full lg:w-1/2 flex justify-center items-center">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-2">
                        {currentVideos.map((video, index) => {
                            const globalIndex = index + (currentPage - 1) * itemsPerPage;

                            return (
                                <div key={globalIndex} className="text-center">
                                    <div className="flex justify-center items-center flex-col">
                                        <div className="relative w-full h-56 md:h-64 lg:h-72 xl:h-96 overflow-hidden">
                                            <video
                                                key={video.id || globalIndex}
                                                ref={(el) => {
                                                    if (el) {
                                                        videoRefs.current[globalIndex] = el;
                                                    } else {
                                                        delete videoRefs.current[globalIndex];
                                                    }
                                                }}
                                                className="w-full h-full object-cover"
                                                onClick={() => handlePlayPause(globalIndex)}
                                                onEnded={() => setPlayingIndex(null)}
                                            >
                                                <source src={video.video} type="video/mp4"/>
                                                Ваш браузер не поддерживает видео.
                                            </video>

                                            {playingIndex !== globalIndex && (
                                                <div
                                                    className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center">
                                                    <button onClick={() => handlePlayPause(globalIndex)}>
                                                        <svg
                                                            width={50}
                                                            height={50}
                                                            stroke="currentColor"
                                                            fill="currentColor"
                                                            strokeWidth="0"
                                                            viewBox="0 0 512 512"
                                                            className="text-white text-6xl"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        <p className="mt-2">{video.name || "Отзыв клиента"}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="flex justify-center items-center mt-6 gap-4 text-sm text-blue-700">
                    <button
                        onClick={handlePrev}
                        disabled={currentPage === 1}
                        className="hover:underline disabled:text-gray-400"
                    >
                        ◀ Предыдущая
                    </button>
                    <span>
            {currentPage} из {totalPages}
          </span>
                    <button
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                        className="hover:underline disabled:text-gray-400"
                    >
                        Следующая ▶
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VideoReviews;
